import styled from "styled-components";
import FirebaseIntro from "../components/Firebase/FirebaseIntro";
import FirebaseWhy from "../components/Firebase/FirebaseWhy";
import FirebaseBenefits from "../components/Firebase/FirebaseBenefits";
import HowItWorksEngagement from "../components/Engagement/HowItWorks";

import GetStartedRequestDemoSide from "../components/generic/GetStartedRequestDemoSide";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { lightThemeColors } from "../assets/style/colors";
import { ReactComponent as GridDecoration } from "../assets/decorations/greenBannerGrid.svg";
import { Helmet } from "react-helmet-async";
import FirebaseGetStarted from "../components/Firebase/FirebaseGetStarted";
import GrovsDeliver from "../components/Marketing/GrovsDeliver";

const Firebase = () => {
  return (
    <>
      <Helmet>
        <title>Migrate from Firebase Dynamic Links to Grovs | Grovs.io</title>
        <meta
          name="description"
          content="Switch from Firebase Dynamic Links to Grovs effortlessly. Modern SDKs, deep-linking, analytics, and campaign tools that just work—out of the box."
        />
        <meta
          name="keywords"
          content="Firebase Dynamic Links migration, replace Firebase links, deep linking alternative, migrate to Grovs, deferred deep linking, Firebase alternative, app install attribution, mobile deep linking SDK, dynamic link migration, smart link platform"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Migrate from Firebase Dynamic Links to Grovs | Grovs.io"
        />
        <meta
          property="og:description"
          content="Grovs makes migrating from Firebase Dynamic Links easy and powerful. Get smart links, SDKs, and advanced attribution with minimal setup."
        />
        <meta
          property="og:url"
          content="https://www.grovs.io/migrate-from-fireabse-dynamic-links"
        />
        <meta
          property="og:image"
          content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Migrate from Firebase Dynamic Links to Grovs | Grovs.io"
        />
        <meta
          name="twitter:description"
          content="Migrate from Firebase Dynamic Links with ease. Grovs offers smarter deep linking, SDKs, and attribution out of the box."
        />
        <meta
          name="twitter:image"
          content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
        />
      </Helmet>
      <Container>
        <FirebaseIntro />
        <FirebaseWhy />
        <FirebaseBenefits />
        <Separator />
        <GrovsDeliver />
        <FirebaseGetStarted
          primaryButtonStyle={{ color: lightThemeColors.lightColor }}
          primaryButtonVariant={lightThemeColors.footerBg}
          outlineButtonStyle={{
            color: lightThemeColors.darkColor,
            background: lightThemeColors.lightColor,
          }}
          outlineButtonVariant={lightThemeColors.lightColor}
        />
        <TrackingComponent />
      </Container>
    </>
  );
};
export default Firebase;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Separator = styled.div`
  height: 100px;
`;
